import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import Link from '../../shared/components/hyperlink';
import ImageWithPlaceholder from '../../shared/components/image-with-placeholder';
import ProductPrice from '../../product/components/product-price';
import withPrices from '../../product/components/product-price/with-product-price';
import { ModalControl } from "../../context/modal/modal-context";
import { Helpers } from '../../core/src/helpers';

import '../css/pdp-oos-popup.less';

class PDPOosPopup extends React.Component {
    state = { 
        hasOpen: false,
        isOOS: false
    }

    static propTypes = {
        backups: PropTypes.array.isRequired,
        sku: PropTypes.string.isRequired
    }

    static getDerivedStateFromProps(props, state) {
        const { sku, prices = {}, pdpDetails, customFields } = props;
        const { forceOOS } = pdpDetails || {}
        const { forceDisplay } = customFields || {};
        const isOOS = forceOOS || forceDisplay || (prices[sku] && prices[sku].stock === 0);
        if ( isOOS !== state.isOOS ) {
            return { isOOS };
        } else {
            return null;
        }
    }

    static MAX_PRODUCTS = 4;

    fetchPrices = () => {
        const { backups, fetchPrices, prices } = this.props;
        let backupIds = backups.reduce( (ids, backup) => {
            let {sku, prdClass, itemId, prodId} = backup;
            const isParentPrd = prdClass === 'PRT';

            // account for parent/non-parent skus, and only fetch if redux doesn't already have the prices
            if( (!itemId && !isParentPrd ) || (!prodId && isParentPrd ) || (prices && prices[sku]) ){
                return ids;
            }

            ids.push(isParentPrd ? prodId : itemId);
            return ids;
        }, [])

        if(backupIds && backupIds.length){
            fetchPrices(backupIds);
        }
    }

    componentDidMount(){
        if(this.state.isOOS){
            this.fetchPrices();
        }
    }

    componentDidUpdate(prevProps, prevState){

        // only fetch prices if it's been determined that the main product is oos
        if( this.state.currentOosSku !== this.props.sku && this.state.isOOS ){
            // don't fetch again for same sku
            this.setState({ currentOosSku: this.props.sku, hasOpen: false }, () => {
                this.fetchPrices();
            });
        }
    }

    renderContent = ({closeModal}) => {

        const { customFields={} } = this.props;
        const { subline, headline, template } = customFields;
        const instockBackups = this.renderBackups(closeModal);
        return (
            <Fragment>
                { headline ? <h6>{headline}</h6> : <h6 className='oos-text'>This product is <span className='text-red'>out of stock</span></h6> } 
                { subline ? <h6>{subline}</h6> : <h6>Here's a similar product you might like:</h6> }
                { instockBackups }
                { typeof template === 'string' && <div dangerouslySetInnerHTML={Helpers.createMarkup(template)} /> }
            </Fragment>
        );
    }

    renderBackups = (closeModal) => {
        const { prices, backups } = this.props;

        return backups.reduce( (instockBackups, backup) => {
                try{
                    if(instockBackups.length === PDPOosPopup.MAX_PRODUCTS){
                        return instockBackups;
                    }

                    const centerFacingImg =backup.images && backup.images.filter(img => img.orientation === 'center_facing')[0];
                    const imageUrl = !!centerFacingImg ? centerFacingImg.lrg : backup.images[0].lrg;

                    const { metadata, sku } = backup|| {};
                    const { jumpId } = metadata || {};

                    if(!prices || !prices[sku] || prices[sku].stock === 0){
                        return instockBackups;
                    }

                    const fullLink = `${process.env.BASENAME}/pdp/${backup.slug}${ jumpId && jumpId.length > 0 ? `?jumpid=${jumpId}` : '' }`;


                    instockBackups.push(
                        <div key={`oos-${sku}`} className='oos-product-tile'>
                            <h3 className='oos-title'>{backup.name}</h3>
                            <ImageWithPlaceholder className='oos-backup-image-item' src={imageUrl}/>
                            <p className='sku-content'>Product # <span className='sku-num'>{backup.sku}</span></p>
                            <ProductPrice product={backup} price={prices[sku]}/>
                            <Link to={fullLink}>
                                <div className='oos-popup-modal-cta' onClick={() => closeModal()}>View Details</div>
                            </Link>
                        </div>
                    );
                }catch(e){}

                return instockBackups;
            }, []);
    }
    
    markOpen = () => this.setState({ hasOpen: true });

    render() {
        const { isOOS, hasOpen } = this.state;
        const { customFields={}, backups, prices, sku } = this.props;
        const { forceDisplay, disableClose } = customFields;
        const shouldOpen = ((isOOS && !hasOpen) || (forceDisplay && !hasOpen));

        // only show backups that are in stock
        let instockBackups = backups && backups.length > 0
                             ? backups.filter(backup => {
                                    let { sku } = backup || {};
                                    return prices && prices[sku] && prices[sku].stock !== 0;
                                })
                             : [];

        return instockBackups.length > 0 ? (
                <div className='oos-popup-container'>
                    <ModalControl
                        content={this.renderContent}
                        atomic={true}
                        modalProps={{
                            className: 'oos-popup-modal',
                            closeOnBGClick: false,
                            disableCloseButton: disableClose
                        }}
                    >   
                        {(props) => (
                            <OpenModal openModal={props.openModal} shouldOpen={shouldOpen} markOpen={this.markOpen}/>
                        )}
                    </ModalControl>
                </div>
        ) : null;
    }
}

export const OpenModal = ({ shouldOpen, markOpen, openModal }) => {
    if ( shouldOpen ) {
        openModal();
        if(markOpen) markOpen();
    }
    return null;
}

export default withPrices(PDPOosPopup);
